import { render, staticRenderFns } from "./loginPw.vue?vue&type=template&id=77213826&scoped=true"
import script from "./loginPw.vue?vue&type=script&lang=js"
export * from "./loginPw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77213826",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77213826')) {
      api.createRecord('77213826', component.options)
    } else {
      api.reload('77213826', component.options)
    }
    module.hot.accept("./loginPw.vue?vue&type=template&id=77213826&scoped=true", function () {
      api.rerender('77213826', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/loginPw.vue"
export default component.exports